
import { Component, Vue } from "vue-property-decorator";

import Search from "@/components/Search.vue";

import CTestingsList from "./components/TestingsList.vue";
import CTestingsChange from "./components/TestingChange.vue";
import CTestingsChangeArchiveTesting from "./components/ChangeArchiveTesting.vue";
import CTestingsFilters, { IFilters } from "./components/Filters.vue";

@Component({
  name: "VProgramTestings",
  components: {
    Search,
    CTestingsFilters,
    CTestingsList,
    CTestingsChange,
    CTestingsChangeArchiveTesting
  }
})
export default class VProgramTestings extends Vue {
  public list_view: boolean = true;
  public filters: IFilters = {
    include_archived: false
  };

  private watchers: Function[] = [];

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  public applyFilter(filters: IFilters) {
    this.filters = filters;
  }
}
